import { Button, Grid, TextField, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import React, { useState } from "react";
import Logo from "../../assets/SFO_LOGO_2021.png";
import { useDispatch } from "react-redux";
import { submitLogin } from "../../redux/reducer/auth/authReducer";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getAllData } from "../../service/Service";
import jwtDecode from "jwt-decode";

const useStyles = makeStyles(() => ({
  loginPage: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    width: "100vw",
    background:"#8da695",
  },
  loginBoxContainer: {
    width: "50%",
    maxWidth: "750px",
    height: "50%",
    background: "white",
    borderRadius: "20px",
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  loginLogo: {
    margin: "auto",
    width: "100%",
    maxWidth: "350px",
  },
  loginFormContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: 10,
  },
  loginForm: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    maxWidth: "400px",
    height: "250px",
    minWidth: "300px",
    background: "white",
    padding: "30px",
    borderRadius: "20px",
  },
}));

export default function Login() {
  // Route State
  const navigate = useNavigate();
  // Material-UI State
  const styles = useStyles();
  // Redux State
  const dispatch = useDispatch();
  // Local State
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [loginBtn, setLoginBtn] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoginBtn(true);
    dispatch(submitLogin(formData)).then((res) => {
      if(res.payload.status === 401){
        toast.error(res.payload.message)
      }else if(res.payload.status === 200){
        toast.success(res.payload.message);
        getAllData(dispatch, res.payload.data)
        const role = jwtDecode(res.payload.data).roleId.roleName;
        if(role === "super-admin" || role === "admin"){
          navigate("/admin")
        }else if(role === "farmer" || role === "supervisor") {
          navigate("/petani")
        }else {
          navigate("/admin")
        }
      }
      setTimeout(() => {
        setLoginBtn(false)
      }, 1000)
    })
  };

  return (
    <div className={styles.loginPage}>
      <ToastContainer/>
      <Grid container direction="row" className={styles.loginBoxContainer}>
        <Box
          component={Grid}
          item
          display={{ xs: "none", sm: "none", md: "flex" }}
          sm={12}
          md={6}
          className={styles.logoContainer}
        >
          <img src={Logo} className={styles.loginLogo} alt="Logo" />
        </Box>
        <Grid item sm={12} md={6} className={styles.loginFormContainer}>
          <form onSubmit={handleSubmit} className={styles.loginForm}>
            <Typography
              textAlign="center"
              fontWeight={600}
              fontSize={24}
              fontStyle={"italic"}
              style={{
                backgroundColor: "#D1D5CD",
                borderRadius: "20px",
                color: "white",
              }}
            >
              SFO ADMIN SITE
            </Typography>
            <TextField
              fullWidth
              required
              name="username"
              label="Username"
              onChange={handleChange}
              variant="standard"
              size="small"
              value={formData.username}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              required
              fullWidth
              type="password"
              name="password"
              label="Password"
              onChange={handleChange}
              variant="standard"
              size="small"
              value={formData.password}
              InputLabelProps={{ shrink: true }}
            />
            <Button
              variant="contained"
              style={{ color: "white" }}
              type="submit"
              disabled={loginBtn}
            >
              LOGIN
            </Button>
          </form>
        </Grid>
      </Grid>
    </div>
  );
}
